// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import { store } from "./store/index";
//

import PageTop from "./components/PageTop.vue";
import HomePage from "./components/HomePage/HomePage.vue";
import Footer from "./components/Blocks/Footer.vue";

import Bike from "./components/Products/Bike.vue";
import Details from "./components/Cart/Details.vue";
import Summary from "./components/Cart/Summary.vue";

import BikesList from "./components/Products/BikesList.vue";
import BikesListInstallment from "./components/Products/BikesListInstallment.vue";
// import BlackFridayList from "./components/Products/BlackFridayList.vue";
import SeriesBikesList from "./components/Products/SeriesBikesList.vue";
import Accessory from "./components/Products/Accessory.vue";
import AccessoriesList from "./components/Products/AccessoriesList.vue";
import Crossseling from "./components/Products/Crossseling.vue";
import Similar from "./components/Products/Similar.vue";
import Popup from "./components/Blocks/Popup.vue";

import Download from "./components/Blocks/Download.vue";
import Installment from "./components/Blocks/Installment.vue";
import ContactForm from "./components/Blocks/ContactForm.vue";
import XmasContact from "./components/Popups/XmasContact.vue";
import PopupContact from "./components/Popups/PopupContact.vue";
import Results from "./components/Search/Results.vue";
import VModal from "vue-js-modal";
import VueCookie from "vue-js-cookie";

import $ from "jquery";

Vue.use(VModal, { dialog: true });
Vue.use(VueCookie);

// plugin jquery do zwiajania bloczków
$.fn.roll = function(options) {
  var settings = $.extend(
    {
      speed: 100
    },
    options
  );

  if (options == "off") {
    this.each(function() {
      $(this)
        .find(".accordion")
        .off("click");
    });
  } else {
    this.each(function() {
      var accordion = $(this).find(".accordion");
      if (accordion.hasClass("show")) {
        accordion
          .next()
          .first()
          .css("display", "block");
      }
      accordion.on("click", function(e) {
        e.preventDefault();
        if ($(this).hasClass("show")) {
          $(this)
            .next()
            .first()
            .slideUp(settings.speed);
        } else {
          $(this)
            .next()
            .first()
            .slideDown(settings.speed);
        }
        $(this).toggleClass("show");
      });
    });
  }
};

Vue.config.productionTip = false;

Vue.filter(
  "full_price",
  value =>
    (Math.round(parseFloat(value) * 100) / 100).toString().replace(".", ",") +
    "<span class='currency-symbol'>&nbsp;PLN</span>"
);
Vue.filter(
  "integer_price",
  value => parseInt(value) + "<span class='currency-symbol'>&nbsp;PLN</span>"
);
Vue.filter("bike_name", function(name, gender) {
  var name_parts = name.split(" ");
  if (name_parts.length > 1) {
    var classes = { F: "kind-f", M: "kind-m", K: "kind-k", U: "kind-u" };
    name_parts[name_parts.length - 1] =
      '<span class="' +
      classes[gender] +
      '">' +
      name_parts[name_parts.length - 1] +
      "</span>";
    return name_parts.join("&nbsp;");
  }
  return name;
});
const EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function() {
      return EventBus;
    }
  }
});
Vue.directive("translate", {
  inserted: function(el, binding) {
    let t = eval(binding.expression.toString());
    if (typeof translations[t] === "string") {
      el.innerHTML = translations[t];
    }
  }
});

$.getJSON(env.baseUrl + "json/products/" + env.language + ".json", function(
  data
) {
  env.data = data;
  renderBlocks();
});

function renderBlocks() {
  let hooks = $(".vue-render");
  let model = "";
  let color = "";

  for (let i = 0; i < hooks.length; i++) {
    let hookId = hooks[i].getAttribute("id");

    switch (hookId) {
      case "page-top":
        new Vue({ el: "#" + hookId, render: h => h(PageTop) });
        break;

      case "home-page":
        new Vue({ el: "#" + hookId, render: h => h(HomePage) });
        break;

      case "bikes-page":
        new Vue({
          el: "#" + hookId,
          components: { BikesList },
          template: "<BikesList></BikesList>"
        });
        break;

      case "full-search":
        let searchString = hooks[i].getAttribute("data-searchString");
        new Vue({
          el: "#" + hookId,
          data() {
            return { searchString };
          },
          components: { Results },
          template: '<Results :searchString="searchString"></Results>'
        });
        break;

      case "contact-form":
        let token = hooks[i].getAttribute("data-token");
        new Vue({
          el: "#" + hookId,
          data: function() {
            return { token };
          },
          components: { ContactForm },
          template: '<ContactForm :token="token"></ContactForm>'
        });
        break;

      case "xsale":
        let productId = hooks[i].getAttribute("data-productId");
        new Vue({
          el: "#" + hookId,
          data: function() {
            return { productId };
          },
          components: { Crossseling },
          template: '<Crossseling :productId="productId"></Crossseling>'
        });
        break;

      case "similar":
        new Vue({
          el: "#" + hookId,
          components: { Similar },
          template: '<Similar :qty="3"></Similar>'
        });
        break;

      case "series-page":
        let series = hooks[i].getAttribute("data-series");
        let first_letter = series[0].toUpperCase();
        new Vue({
          el: "#" + hookId,
          data: function() {
            return { series: first_letter + series.substr(1) };
          },
          components: { SeriesBikesList },
          template: '<SeriesBikesList :series="series" ></SeriesBikesList>'
        });
        break;

      case "bike":
        model = hooks[i].getAttribute("data-model");
        color = hooks[i].getAttribute("data-color");
        new Vue({
          el: "#" + hookId,
          data: function() {
            return { model, color };
          },
          components: { Bike },
          template: '<Bike :model="model" :color="color" ></Bike>'
        });
        break;
      case "accessory":
        model = hooks[i].getAttribute("data-model");
        color = hooks[i].getAttribute("data-color");
        new Vue({
          el: "#" + hookId,
          data: function() {
            return { model, color };
          },
          components: { Accessory },
          template: '<Accessory :model="model" :color="color"></Accessory>'
        });
        break;

      case "accessories-page":
        let group = hooks[i].getAttribute("data-group");

        new Vue({
          el: "#" + hookId,
          data: function() {
            return {
              group: group
            };
          },
          components: { AccessoriesList },
          template: '<AccessoriesList :group="group"></AccessoriesList>'
        });
        break;
      // case "black-friday-page" :
      //   new Vue({ el: "#" + hookId, render: h => h(BlackFridayList) });
      //   break;
      case "popup-xmas-contact":
        new Vue({ el: "#" + hookId, render: h => h(XmasContact) });
        break;

      case "popup-contact":
        new Vue({ el: "#" + hookId, render: h => h(PopupContact) });
        break;

      case "download":
        new Vue({ el: "#" + hookId, render: h => h(Download) });
        break;
      case "footer":
        new Vue({ el: "#" + hookId, render: h => h(Footer) });
        break;
      case "cart-summary-form":
        new Vue({ el: "#" + hookId, render: h => h(Summary) });
        break;
      case "cart-details-form":
        new Vue({ el: "#" + hookId, render: h => h(Details) });
        break;
      case "installment":
        new Vue({ el: "#" + hookId, render: h => h(Installment) });
        break;
      case "bikes-page-new":
        new Vue({ el: "#" + hookId, render: h => h(BikesListInstallment) });
        break;
      case "download-new":
        new Vue({ el: "#" + hookId, render: h => h(Download) });
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/main.js